import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const QuoteShape = ({
  width = 800,
  height = 800,
  fillColor = '#FFF',
  style
}: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 10 10"
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <g opacity="0.5">
      <path
        d="M2.33344 1.30078C1.04471 1.30078 0 2.34578 0 3.63496C0 4.92369 1.04471 5.96869 2.33344 5.96869C2.33344 5.96869 2.32215 6.83572 1.61777 8.08361C1.53953 8.33365 1.679 8.59992 1.9292 8.67771C2.10672 8.73355 2.29352 8.67928 2.41414 8.55293C4.03377 6.78145 4.66775 4.69652 4.66775 3.63496C4.66775 2.34578 3.62307 1.30078 2.33344 1.30078Z"
        fill={fillColor}
      />
      <path
        d="M7.66565 1.30078C6.37692 1.30078 5.33221 2.3458 5.33221 3.63496C5.33221 4.92369 6.37692 5.96869 7.66565 5.96869C7.66565 5.96869 7.65436 6.83572 6.94999 8.08361C6.87175 8.33365 7.01124 8.59992 7.26141 8.67771C7.43893 8.73355 7.62573 8.67928 7.74634 8.55293C9.36598 6.78145 9.99999 4.69652 9.99999 3.63496C9.99999 2.34578 8.95528 1.30078 7.66565 1.30078Z"
        fill={fillColor}
      />
    </g>
  </svg>
);

export default QuoteShape;
